import { createProvider } from '@nvision/services/data-provider';

import type { Contract } from '../../models';
import { logger } from '../../utils/logger';
import * as api from './api';
import { normalizeUpdateContract } from './normalize';

export const updateContract = createProvider(
  (contract: Contract, options: { signal?: AbortController['signal'] } = {}) =>
    api.updateContract(contract.key, normalizeUpdateContract(contract), options),
)
  .andThen((res) => res)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      logger.warn('Update contract is aborted');
    } else {
      logger.error(`Update contract was failed: ${error}`);
    }
    throw error;
  });
